import { Tariff, ProductSegment } from 'api';
import * as actions from './actionTypes';

export const getTariffs = () => ({
	type: actions.GET_TARIFFS,
});

export const getTariff = (id: number) => ({
	type: actions.GET_TARIFF,
	payload: id,
});

export const getTariffsForPortfolio = (
	portfolioId: number,
	tariffSegment: ProductSegment
) => ({
	type: actions.GET_TARIFFS_FOR_PORTFOLIO,
	payload: portfolioId,
	tariffSegment,
});

export const setTariffs = (tariffs: Tariff[]) => ({
	type: actions.SET_TARIFFS,
	payload: tariffs,
});

export const setTariff = (tariff: Tariff) => ({
	type: actions.SET_TARIFF,
	payload: tariff,
});

export const tariffResetAll = () => ({
	type: actions.TARIFF_RESET_ALL,
});

export const tariffError = (error: string) => ({
	type: actions.TARIFF_ERROR,
	payload: error,
});

export const tariffClearError = () => ({
	type: actions.TARIFF_CLEAR_ERROR,
});
